import React from "react";
import { FormGroup, Label } from "reactstrap";
import Switch from "react-switch";
import { FieldProps } from "formik";

import FormikFieldCustomProps from "../field/formikfieldcustomprops";

const ReactCommonSwitch: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field: { name, value, onChange },
  form: { setFieldValue },
  ...props
}) => {
  // const [checked, setChecked] = React.useState(value);
  return (
    <FormGroup>
      <Label className="label-switch">{props.label}</Label>
      <br />
      <div className={`r-common-switch ${value ? 'checked-bg' : 'unchecked-bg' }`}>
        <Switch
          {...props}
          height={25}
          width={48}
          handleDiameter={20}
          checked={value}
          disabled={props.disabled || false}
          onChange={(value: any) => {
            setFieldValue(name, value);
            // setChecked(!checked)
          }}
          uncheckedIcon={
            <div className="switch-text">
              {/* <span>OFF</span> */}
            </div>
          }
          checkedIcon={
            <div className="switch-text">
              {/* <span>ON</span> */}
            </div>
          }
        />
      </div>
    </FormGroup>
  )
}

export default ReactCommonSwitch;